const queryParameters = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid',
  'ref'
]

try {
  const urlSearchParams = new window.URLSearchParams(window.location.search)
  const currentCookie = document.cookie.match(/(^| )campaign=([^;]+)/)
  let parameters = {}

  if (currentCookie) {
    parameters = JSON.parse(currentCookie[2])
  }

  for (const [parameter, value] of urlSearchParams.entries()) {
    if (queryParameters.includes(parameter)) {
      parameters[parameter] = value
    }

    if (parameter === 's') {
      document.cookie = `ref=${value};path=/;domain=${process.env.COOKIE_DOMAIN}`
    }
  }

  document.cookie = `campaign=${JSON.stringify(parameters)};path=/;domain=${process.env.COOKIE_DOMAIN}`
} catch (error) {
  // do nothing here
}
